import React, { useRef, useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const NewArrivals = () => {
  const scrollRef = useRef(null);
  const [newArrivals, setNewArrivals] = useState([]);

  // Fetch products from API
  useEffect(() => {
    async function fetchLatestProducts() {
      try {
        const res = await fetch("/api/products");
        const data = await res.json();

        // Assuming the API returns { products: [...] }
        if (data.products && data.products.length > 0) {
          // Sort by newest (assuming the last items are newest)
          const sortedProducts = data.products
            .sort((a, b) => new Date(b._id) - new Date(a._id)) // if _id is ObjectId like MongoDB
            .slice(0, 8); // get last 8 products

          setNewArrivals(sortedProducts);
        }
      } catch (err) {
        console.error("Failed to fetch products:", err);
      }
    }

    fetchLatestProducts();
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="container mx-auto mb-[70px] md:mb-[70px]">
      {/* Heading */}
      <div className="text-center mb-[40px] relative">
        <div className="mb-5">
          <h1 className="text-[20px] poppins md:text-[33px] font-bold mb-4">
            Explore Our New Arrivals
          </h1>
          <p className="text-[10px] md:text-[15px] text-gray-600 px-4 pb-6 w-full text-center mb-8">
            Stay ahead of the trends with our latest collections—new styles curated to elevate your wardrobe.
          </p>
        </div>

        {/* Scroll Buttons */}
        <div className="absolute right-0 bottom-[-30px] px-4 flex space-x-2">
          <button onClick={() => scroll("left")} className="p-2 rounded border bg-white text-black">
            <FiChevronLeft className="text-2xl" />
          </button>
          <button onClick={() => scroll("right")} className="p-2 rounded border bg-white text-black">
            <FiChevronRight className="text-2xl" />
          </button>
        </div>
      </div>

      {/* Scrollable Content */}
      <div ref={scrollRef} className="overflow-x-scroll whitespace-nowrap flex space-x-3 backdrop-blur-md scrollbar-hide px-3 scroll-smooth">
        {newArrivals.length > 0 ? (
          newArrivals.map((product) => {
            const img = product.variants?.[0]?.images?.[0]?.src || "/placeholder.jpg";
            const price = product.price || product.variants?.[0]?.variantPrice;

            return (
              <div key={product._id} className="relative min-w-[300px] min-h-[300px]">
                {/* Product Image */}
                <img src={img} alt={product.model} className="w-full h-full object-cover" />

                {/* Overlay with Product Details */}
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-3">
                  <Link
                    to={`/product/${product._id}`}
                    state={{ product }}
                    className="block"
                  >
                    <h4 className="poppins font-bold">{product.model}</h4>
                    {product.sale?.isOnSale ? (
                      <div className="flex flex-col">
                        <span className="text-red-400 font-bold">
                          {product.sale.finalPrice.toLocaleString()} DT
                        </span>
                        <span className="text-gray-300 text-xs line-through">
                          {product.price.toLocaleString()} DT
                        </span>
                      </div>
                    ) : (
                      <p className="mt-1 poppins">
                        {(product.sale?.finalPrice || product.price).toLocaleString()} DT
                      </p>
                    )}
                  </Link>
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-gray-500 text-center w-full py-10">Loading latest products...</p>
        )}
      </div>
    </section>
  );
};

export default NewArrivals;
